module.exports = __webpack_public_path__ + "img/preloader.8fe516d4.png";